import React, {useState, useEffect} from 'react'
import {Modal,Row, Col} from 'react-bootstrap'

const RemoveUserConfirmation = (props) => {

    const [userName, setUserName] = useState('')
  
    useEffect(() => {
        setUserName(props.user_name)
    }, [props])

    const removeUser = async (event)=>{
        event.preventDefault()
        if(userName){
            props.handleRemove()
            // Clear the form
            resetState()
            props.onHide()
        }                  
    }

    const cancelRemoval = ()=>{
            resetState()
            props.unSelectRow()
            props.onHide()
    }
    const resetState = ()=>{
        setUserName('')
    }

    return (
        <div>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                
                        Are you sure to remove {userName}? 
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className='modal-body'>
                        <Row className="mb-3" controlId="orgName">
                            <Col sm='6'>
                            <div className='btn-centre'>
                                 <button className='protondx-btn-danger btn-lg btn-align' onClick={removeUser}>Remove User</button>
                            </div>
                            </Col>
                            <Col sm="6">
                            <div className='btn-centre'>
                                 <button className='protondx-btn-primary btn-lg btn-align' onClick={cancelRemoval}>Cancel</button>
                            </div>
                            </Col>
                        </Row>
                </div>
                    </Modal.Body>
            </Modal>
        </div>
    )
}

export default RemoveUserConfirmation
